import api, { api_v2 } from "@/api/axios.config"

interface AuthData {
  access_token: string
  expires_in: number
  token_type: string
}

export interface ApiResponse<T> {
  success: boolean
  message: string
  data: T
}

export interface ImpersonationUser {
  pesId: number
  pesUid: string
  pesNome: string
  pesCpf: string
  pesEmail: string
  pesFotoUrl: string
  empId: number
  empUid: string
  empNome: string
  gestaoApp: boolean
  pesTipo: number
  pesAdmin: boolean
}

export interface ImpersonateResponse {
  success: boolean
  user: ImpersonationUser
  token: { ImpersonationToken: string }
}

export interface PessoaBuscaDataType {
  pes_id: number
  pes_uid: string
  pes_nome: string
  pes_email: string
  pes_cpf: string
  pes_telefone: string
  pes_admin: boolean
  pes_tipo: number
  pes_tipo_desc: string
  pes_tem_foto: number
  pes_foto_url: string
  emp_id: number
  emp_uid: string
  emp_razaosocial: string
  emp_fantasia: string
  [key: string]: unknown
}

export const authenticate = async (): Promise<{authData: AuthData}> => {
  const { data } = await api.post("/autenticacao", {
    client_id: import.meta.env.VITE_CLIENT_ID,
    client_secret: import.meta.env.VITE_CLIENT_SECRET,
  })

  return { authData: data }
}

export const autenticacaoToken = async (email: string) => {
  return api.post("/autenticacao-token", { email })
}

export const validarToken = async (email: string, token: string) => {
  return api.post("/validar-token", { email, token })
}

export const plataformaAutenticacaoToken = async (email: string) => {
  return api_v2.post("/auth/plataforma/autenticacao", { email })
}

export const plataformaLogin = async (
  email: string,
  valor?: string,
  tipo?: string,
  token?: string
) => {
  return api_v2.post("/auth/plataforma/login", { email, valor, tipo, token })
}

export const refreshToken = async (refreshToken: string) => {
  return api_v2.post("/auth/plataforma/refresh-token", { refreshToken })
}

export const recuperaSenha = async (email: string) => {
  return api.post("/plataforma/recupera-senha", { email })
}

export const plataformaResetPass = async (email: string, nova_senha: string, token?: string) => {
  return api.post("/plataforma/reset-senha", { email, nova_senha, token })
}

export const requestPasswordReset = async (email: string) => {
  return api_v2.post("/auth/plataforma/request-password-reset", { email })
}

export const validateOtp = async (email: string, otp: string) => {
  return api_v2.post("/auth/plataforma/validate-otp", { email, otp })
}

export const resetPassword = async (resetToken: string, novaSenha: string) => {
  return api_v2.post("/auth/plataforma/reset-password", { resetToken, novaSenha })
}

export const findPessoaByEmail = async (email: string) => {
  return api.get<{ total: number; data: PessoaBuscaDataType[] }>("/membros-complete", {
    params: { pes_email: email },
  })
}

export const impersonateUser = async (pesId: number) => {
  return api_v2.post<ApiResponse<ImpersonateResponse>>("/auth/plataforma/impersonate", { pesId })
}

export const endImpersonationRequest = async () => {
  return api_v2.post("/auth/impersonate/end")
}

export const updateUserWhatsSell = async (emp_id: number, userWhatSell: string) => {
  return api.post(`/empresas/${emp_id}/editar`, { emp_o_que_vende: userWhatSell })
}
